<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <!-- <div > -->
      <div
        v-for="item in computedOrigin"
        :key="item.stock_storehouse_id"
        class="status"
        :class="{ active: origin_id == item.stock_storehouse_id }"
        @click="selectOrigin(item.stock_storehouse_id)"
      >
        {{ item.storehouse_name }}
      </div>
      <!-- </div> -->
    </div>

    <!-- tab 按件数 start -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="按件数添加" name="5">
        <el-row>
          <el-form
            ref="form"
            :inline="true"
            :model="form"
            class="demo-form-inline"
          >
            <el-form-item label="波次件数">
              <el-input
                v-model="form.wave_min"
                style="width: 100px"
                placeholder="最少件数"
              ></el-input
              >-
              <el-input
                v-model="form.wave_max"
                style="width: 100px"
                placeholder="最大件数"
              ></el-input>
            </el-form-item>
            <el-form-item label="发送快递">
              <el-select v-model="form.shipping_company" placeholder="发送快递">
                <el-option
                  v-for="shipping in resData.shipping"
                  :key="shipping.cpid"
                  :label="shipping.shipping_company"
                  :value="shipping.cpid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">添加</el-button>
            </el-form-item>
            <el-form-item label="其他" style="float: right">
              <el-select
                v-model="form.default_shipping"
                placeholder="发送快递"
                @change="saveDefault"
              >
                <el-option
                  v-for="shipping in resData.shipping"
                  :key="shipping.cpid"
                  :label="shipping.shipping_company"
                  :value="shipping.cpid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row v-if="!loading">
          <el-col style="border: 1px solid #ddd">
            <div v-if="resData.list" style="margin-bottom: 0">
              <el-table
                ref="multipleTable"
                v-loading="tableLoading"
                height="600"
                :data="resData.list"
                tooltip-effect="dark"
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="wave_num"
                  label="波次件数"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="shipping_company"
                  label="发送快递"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="admin_name"
                  label="更新人"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="create_time"
                  label="更新时间"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  show-overflow-tooltip
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleDel(scope.row, 5)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- tab 按件数 end -->

      <!-- tab 按地区 start -->
      <el-tab-pane label="按地区添加" name="10">
        <el-row>
          <el-form
            ref="form"
            :inline="true"
            :model="form"
            class="demo-form-inline"
          >
            <el-form-item prop="province">
              <el-select
                v-model="form.province"
                multiple
                style="width: 150px"
                placeholder="省"
                @change="getCity"
              >
                <el-option
                  v-for="item in resData.province"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="city">
              <el-select
                v-model="form.city"
                multiple
                style="width: 150px"
                placeholder="市"
                @change="getDistrict"
              >
                <el-option
                  v-for="item in cityData.list"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="district">
              <el-select
                v-model="form.district"
                multiple
                style="width: 150px"
                placeholder="区/县"
              >
                <el-option
                  v-for="item in districtData.list"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="shipping_company">
              <el-select v-model="form.shipping_company" placeholder="发送快递">
                <el-option
                  v-for="shipping in resData.shipping"
                  :key="shipping.cpid"
                  :label="shipping.shipping_company"
                  :value="shipping.cpid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="fetchData">查询</el-button>
              <el-button type="primary" @click="resetForm('form')">
                重置</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="showImportShippingRuleMesaage">
                地区快递设置导入</el-button
              >
              <el-upload
                ref="upload"
                style="margin: 0 10px 2px"
                :action="action"
                name="excel"
                :data="{ origin_id: origin_id }"
                :limit="1"
                :on-success="importFile"
                :file-list="fileList"
                :auto-upload="false"
                with-credentials
              >
                <el-button ref="uploadButton" style="display: none"></el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="outputMb">
                导出系统省市区</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="outputData">导出</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row v-if="!loading">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              padding: 0 25px;
              display: flex;
              align-items: center;
            "
          >
            <div>数据列表：</div>
            <el-button
              style="margin-left: auto"
              type="primary"
              size="mini"
              @click="dialogFormVisible = true"
            >
              添加</el-button
            >
            <el-button type="danger" size="mini" @click="batchDelete(10)">
              批量删除</el-button
            >
          </div>
          <el-col style="border: 1px solid #ddd">
            <div v-if="resData.list" style="margin-bottom: 0">
              <el-table
                ref="multipleTable"
                v-loading="tableLoading"
                height="600"
                :data="resData.list"
                tooltip-effect="dark"
                style="width: 100%"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="province"
                  label="省"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column prop="city" label="市" align="center">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <p>{{ scope.row.city }}</p>
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.city }}</el-tag>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="district"
                  label="区县"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="wave_num"
                  label="波次件数"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="shipping_company"
                  label="发送快递"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="admin_name"
                  label="更新人"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="update_time"
                  label="更新时间"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  show-overflow-tooltip
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleDel(scope.row, 10)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- http://abc.yishouapp.com:8080/#/home/wavepicking/shippingRule -->
            </div>
            <el-pagination
              v-if="areaData_10.total"
              style="text-align: right"
              background
              layout="prev, pager, next, jumper"
              :total="areaData_10.total"
              :page-size="areaData_10.psize"
              :current-page="areaData_10.page"
              @current-change="cahngePage"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- tab 按地区 end -->

      <!-- tab 按用户 start -->
      <el-tab-pane label="按用户添加" name="15">
        <el-row>
          <el-form
            ref="form15"
            :inline="true"
            :model="form15"
            class="demo-form-inline"
          >
            <el-form-item label="用户id">
              <el-input
                v-model="form15.user_ids"
                style="width: 400px"
                placeholder="用户id,多个用户id请用英文逗号隔开"
              ></el-input>
            </el-form-item>
            <el-form-item label="发送快递">
              <el-select
                v-model="form15.shipping_company"
                placeholder="发送快递"
              >
                <el-option
                  v-for="shipping in resData.shipping"
                  :key="shipping.cpid"
                  :label="shipping.shipping_company"
                  :value="shipping.cpid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit15">添加</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row v-if="!loading">
          <el-col style="border: 1px solid #ddd">
            <div v-if="resData.list" style="margin-bottom: 0">
              <el-table
                ref="multipleTable"
                v-loading="tableLoading"
                height="600"
                :data="resData.list"
                tooltip-effect="dark"
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="user_ids"
                  label="用户id"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="shipping_company"
                  label="发送快递"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="admin_name"
                  label="更新人"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="create_time"
                  label="更新时间"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  show-overflow-tooltip
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleDel(scope.row, 15)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>

      <!-- tab 按用户 end -->
      <el-tab-pane label="快递费率表" name="16">
        <ExpressRateSchedule :origin-id="origin_id"></ExpressRateSchedule>
      </el-tab-pane>
      <el-tab-pane label="快递时效表" name="17">
        <ShippingAgingList :origin-id="origin_id"></ShippingAgingList>
      </el-tab-pane>
      <el-tab-pane label="物流联通表" name="18">
        <ShippingConnectList :origin-id="origin_id"></ShippingConnectList>
      </el-tab-pane>
      <el-tab-pane label="物流合作表" name="19">
        <ShippingCooperate :origin-id="origin_id" />
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="添加" :visible.sync="dialogFormVisible" width="30%">
      <el-form ref="form10" :model="form10">
        <el-form-item label="省" label-width="120px" prop="province">
          <el-select
            v-model="form10.province"
            placeholder="省"
            @change="getCity"
          >
            <el-option
              v-for="item in resData.province"
              :key="item.region_id"
              :label="item.region_name"
              :value="item.region_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市" label-width="120px" prop="city">
          <el-select
            v-model="form10.city"
            placeholder="市"
            @change="getDistrict"
          >
            <el-option
              v-for="item in cityData.list"
              :key="item.region_id"
              :label="item.region_name"
              :value="item.region_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区/县" label-width="120px" prop="district">
          <el-select v-model="form10.district" placeholder="区/县">
            <el-option
              v-for="item in districtData.list"
              :key="item.region_id"
              :label="item.region_name"
              :value="item.region_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始波次件数" label-width="120px" prop="wave_min">
          <el-input
            v-model="form10.wave_min"
            placeholder="起始波次件数"
          ></el-input>
        </el-form-item>
        <el-form-item label="终止波次件数" label-width="120px" prop="wave_max">
          <el-input
            v-model="form10.wave_max"
            placeholder="终止波次件数"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="发送快递"
          label-width="120px"
          prop="shipping_company"
        >
          <el-select v-model="form10.shipping_company" placeholder="发送快递">
            <el-option
              v-for="shipping in resData.shipping"
              :key="shipping.cpid"
              :label="shipping.shipping_company"
              :value="shipping.cpid"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit10">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import apiBaseURL from "@/utils/baseUrl.js";

import ShippingConnectList from "./components/ShippingConnectList.vue";
import ShippingAgingList from "./components/ShippingAgingList.vue";
import ExpressRateSchedule from "./components/ExpressRateSchedule.vue";
import ShippingCooperate from "./components/ShippingCooperate.vue";

const TAB_NAME = {
  ADD_BY_NUM: "5",
  ADD_BY_REGION: "10",
  ADD_BY_USER: "15",
  DELIVERY_RATE_TABLE: "16",
  DELIVERY_TIME_TABLE: "17",
  LOGISTIC_UNION_TABLE: "18",
};

export default {
  name: "ShippingRule",
  components: {
    ShippingConnectList,
    ShippingAgingList,
    ExpressRateSchedule,
    ShippingCooperate,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      dialogFormVisible: false,
      activeName: "18",
      resData: {
        setting: "未配置数据",
      },
      cityData: {},
      districtData: {},
      form: {
        type: TAB_NAME.ADD_BY_NUM,
        default_shipping: "",
        wave_min: null,
        wave_max: null,
        cpid: null,
        shipping_company: "",
        province: null,
        city: null,
        distinct: null,
      },
      form10: {
        type: TAB_NAME.ADD_BY_REGION,
        wave_min: null,
        wave_max: null,
        cpid: null,
        province: null,
        city: null,
      },
      form15: {
        type: TAB_NAME.ADD_BY_USER,
        cpid: null,
        user_ids: null,
      },
      fileList: [],
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/ShippingRule",
      saveurl: "/erp/WavePicking/shippingRuleSave",
      delurl: "/erp/WavePicking/shippingRuleDel",
      batchdelurl: "/erp/WavePicking/shippingRuleBatchDel",
      origin: [],
      origin_id: "1",
      type: TAB_NAME.ADD_BY_NUM,

      // 按区域添加的话数据加载太多 需要分页
      areaData_10: {
        total: 0,
        psize: 100,
        page: 1,
      },
      ids: [],
      TAB_NAME,
      action: `${apiBaseURL}/erp/WavePicking/importSRSetting`,
    };
  },
  computed: {
    filteredForm() {
      const filterdForm = cloneDeep(this.form);
      Object.keys(filterdForm).forEach((key) => {
        if (
          filterdForm[key] === undefined ||
          filterdForm[key] === "" ||
          filterdForm[key] === null
        ) {
          delete filterdForm[key];
        }
      });
      filterdForm.origin_id = this.origin_id;
      filterdForm.type = this.type;
      return filterdForm;
    },
    filteredForm10() {
      const filterdForm = cloneDeep(this.form10);
      Object.keys(filterdForm).forEach((key) => {
        if (
          filterdForm[key] === undefined ||
          filterdForm[key] === "" ||
          filterdForm[key] === null
        ) {
          delete filterdForm[key];
        }
      });
      filterdForm.origin_id = this.origin_id;
      filterdForm.type = this.type;
      return filterdForm;
    },
    filteredForm15() {
      const filterdForm = cloneDeep(this.form15);
      Object.keys(filterdForm).forEach((key) => {
        if (
          filterdForm[key] === undefined ||
          filterdForm[key] === "" ||
          filterdForm[key] === null
        ) {
          delete filterdForm[key];
        }
      });
      filterdForm.origin_id = this.origin_id;
      filterdForm.type = this.type;
      return filterdForm;
    },
    computedOrigin() {
      return this.origin.filter((o) => o.stock_storehouse_id !== -1);
    },
  },
  methods: {
    cahngePage(page) {
      this.areaData_10.page = page;
      this.fetchData();
    },
    tableRowClassName({ row }) {
      if (Number(row.is_stock) === 1) {
        return "stock-row";
      }
      return "";
    },
    handleClick() {
      this.type = Number(this.activeName);
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    selectOrigin(key) {
      this.origin_id = key;
      this.form.type = TAB_NAME.ADD_BY_NUM;

      this.fetchData(true);
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      const _form = cloneDeep(this.filteredForm);
      if (_form.type === TAB_NAME.ADD_BY_REGION) {
        Object.assign(_form, {
          page: this.areaData_10.page,
          psize: this.areaData_10.psize,
        });
      }
      this.$http.post(this.url, _form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.resData.origin;
          this.origin_id = this.resData.origin_id;
          if (this.resData.default) {
            this.form.default_shipping = this.resData.default.shipping_company;
          } else {
            this.form.default_shipping = "";
          }
          this.areaData_10.total = res.data.data.count || 0;
        }
      });
    },
    getCity(value) {
      this.$http
        .post("/erp/WavePicking/getCityArr", { province: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.cityData = res.data.data;
          }
        });
    },
    getDistrict(value) {
      this.$http
        .post("/erp/WavePicking/getDistrict", { city: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.districtData = res.data.data;
          }
        });
    },
    handleDel(row, type) {
      this.$confirm("删除此规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {};
          if (type === TAB_NAME.ADD_BY_NUM) {
            data = {
              spr_id: row.spr_id,
              type,
            };
          } else if (type === TAB_NAME.ADD_BY_REGION) {
            data = {
              spr_id: row.spr_id,
              type,
            };
          } else if (type === TAB_NAME.ADD_BY_USER) {
            data = {
              type,
              timestamp: row.timestamp,
              cpid: row.cpid,
              origin_id: this.origin_id,
            };
          }
          this.$http.post(this.delurl, data).then((res) => {
            if (res.data.code !== 200) {
              this.$message({
                type: "info",
                message: res.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.fetchData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.saveurl, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.resetForm("form");
          this.fetchData(true);
        }
      });
    },
    onSubmit10() {
      this.loading = true;
      this.$http.post(this.saveurl, this.filteredForm10).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.dialogFormVisible = false;
          this.resetForm("form10");
          this.fetchData(true);
        }
      });
    },
    onSubmit15() {
      this.loading = true;
      this.$http.post(this.saveurl, this.filteredForm15).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.resetForm("form15");
          this.fetchData(true);
        }
      });
    },
    saveDefault(value) {
      this.loading = true;
      const data = {
        type: 1,
        origin_id: this.form.origin_id,
        shipping_company: value,
      };
      this.$http.post(this.saveurl, data).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.fetchData(true);
        }
      });
    },
    resetForm(ref) {
      this.$refs[ref].resetFields();
    },
    // 导出省市区模板
    outputMb() {
      this.$http.post("/erp/WavePicking/exportRegionData").then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    outputData() {
      const params = cloneDeep(this.filteredForm);
      this.$http.post(this.url, { ...params, is_excel: 1 }).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    // 导入地区快递设置
    importFile(res) {
      this.fileList = []; // 删除下方文件名
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else {
        this.$message.success("导入处理完成,请打开相应的下载文件查看导入结果");
        this.fetchData();
        setTimeout(() => {
          window.open(apiBaseURL + res.data.file);
        }, 0);
      }
    },
    showImportShippingRuleMesaage() {
      const h = this.$createElement;
      this.$msgbox({
        title: "地区快递设置导入",
        message: h("p", null, [
          h(
            "el-button",
            {
              attrs: {
                type: "danger",
                size: "mini",
              },
              on: {
                click: () => {
                  this.$http
                    .post("/erp/WavePicking/downloadShippingRuleExcelTemplate")
                    .then((res) => {
                      window.open(apiBaseURL + res.data.data.file);
                    });
                },
              },
            },
            "下载导入模板"
          ),
          h("p", null, "说明：省、市、区/县必须以“导出系统省市区”内的数据为准"),
          h(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "mini",
              },
              on: {
                click: () => {
                  this.$refs.uploadButton.$el.click();
                },
              },
            },
            "选择导入文件"
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.$refs.upload.submit();
          } else {
            this.fileList = [];
          }
          done();
        },
      });
    },
    batchDelete(type) {
      this.$confirm("确定批量删除规则吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.ids.length <= 0) {
          this.$message.error("请选择要删除的记录");
          return;
        }
        this.$http
          .post(this.batchdelurl, {
            ids: this.ids,
            type,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
            }
          });
      });
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((item) => {
        this.ids.push(item.spr_id);
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/ShippingRule/ShippingRule.vue